export const decorStyles = [
  'Americana',
  'Art Deco',
  'Asian',
  'Bohemian',
  'Coastal',
  'Contemporary',
  'Country & Cottage',
  'Craftsman & Mission',
  'Danish Modern',
  'Eclectic',
  'Farmhouse',
  'French Country',
  'Glam',
  'Industrial',
  'Mediterranean',
  'Mid-Century Modern',
  'Minimalist',
  'Modern',
  'Old World',
  'Pastoral',
  'Rustic',
  'Scandinavian',
  'Shabby Chic',
  'Southwestern',
  'Traditional',
  'Transitional',
  'Tropical',
  'Victorian',
  'Vintage'
]
